import { jsxs, jsx } from 'react/jsx-runtime';
import { ErrorMessage, Button } from '@sketch/components';
import { IndexLayoutHeader } from './IndexLayoutHeader.js';
import { Wrapper } from './IndexLayout.styles.js';
import Sidebar from './Sidebar.js';

const IndexLayoutError = ({ headerLink, variant, }) => (jsxs(Wrapper, { children: [jsx(IndexLayoutHeader, { headerLink: headerLink, blockLogoLink: true }), variant && jsx(Sidebar, { variant: variant }), jsx(ErrorMessage.Generic, { title: "There was an error loading this page", extra: jsx(Button, Object.assign({ variant: "primary", onClick: () => window.location.reload() }, { children: "Refresh the page to try again" })) })] }));

export { IndexLayoutError };
